var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "watch-round-svgrepo-com",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.843,
    height: 28.348,
    viewBox: "0 0 19.843 28.348",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1213b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a6192e"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7446",
    "data-name": "Trazado 7446",
    d: "M14.922,24.8A9.889,9.889,0,1,0,5,14.912,9.905,9.905,0,0,0,14.922,24.8Zm0-14.934a.991.991,0,0,1,.992.989v3.636l2.341,2.244A.99.99,0,1,1,16.88,18.16l-2.646-2.536a.987.987,0,0,1-.3-.713V10.855A.991.991,0,0,1,14.922,9.866Z",
    transform: "translate(-5 -0.738)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7447",
    "data-name": "Trazado 7447",
    d: "M10.806,2.105A24.318,24.318,0,0,1,13.772,2h.137a24.318,24.318,0,0,1,2.967.105,3.61,3.61,0,0,1,2.183.957,3.586,3.586,0,0,1,.96,2.176c.035.257.058.535.074.835a11.951,11.951,0,0,0-12.5,0c.016-.3.039-.579.074-.835a3.586,3.586,0,0,1,.96-2.176A3.61,3.61,0,0,1,10.806,2.105Z",
    transform: "translate(-3.919 -2)",
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7448",
    "data-name": "Trazado 7448",
    d: "M19.059,22.137a3.586,3.586,0,0,0,.96-2.176c.035-.257.058-.535.074-.835a11.951,11.951,0,0,1-12.5,0c.016.3.039.579.074.835a3.586,3.586,0,0,0,.96,2.176,3.611,3.611,0,0,0,2.183.957,24.354,24.354,0,0,0,2.967.105h.137a24.353,24.353,0,0,0,2.967-.105A3.611,3.611,0,0,0,19.059,22.137Z",
    transform: "translate(-3.919 5.148)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatch);
export default __webpack_public_path__ + "static/media/watch.229301ce5c07fc9b6472f02f9f6c92c8.svg";
export { ForwardRef as ReactComponent };